import { isGlobal81 } from '@/helpers/wallet';
import type { WalletType } from '@/types/WalletType';
import { SHAREHOLDERS_MODAL_COUNTRY_CL } from '../constants/shareholdersModal.constant';

/**
 * Determina si la cuenta es Global81 chilena (caso especial para beneficiarios finales).
 * @param companyCountry - Código del país de la empresa.
 * @param mainWallet - Wallet principal del usuario.
 * @returns `true` si es una cuenta Global81 de Chile.
 */
export function isCompanyGlobal81Chile(
  companyCountry: string,
  mainWallet: WalletType
): boolean {
  return (
    companyCountry === SHAREHOLDERS_MODAL_COUNTRY_CL && isGlobal81(mainWallet, 'CLP')
  );
}
